import React from 'react';
import { resolveRunColumns } from 'features/agent-analytics/utils/runColumns';
import { renderCell } from 'features/agent-analytics/components/runCells';
import {
  tableHeaderRowClass,
  tableHeaderCellClass,
  tableRowClass,
  tableDataCellClass,
} from 'features/activity/styles/dataTableStyles';

export default function AgentRunsTable({
  rows,
  columnKeys,
  onRowClick,
  onAnnotationClick,
  selectedRunId = null,
  emptyMessage = 'No runs match the current filters.',
  // Tick boxes for "Add to dataset…": a Set of run ids and the toggles. Absent → no column.
  checkedIds = null,
  onToggleChecked = null,
  onToggleAllChecked = null,
}) {
  const columns = React.useMemo(() => resolveRunColumns(columnKeys), [columnKeys]);
  const selectable = Boolean(checkedIds && onToggleChecked);
  const allChecked = selectable && rows?.length > 0 && rows.every((r) => checkedIds.has(r.run_id));

  if (!rows || rows.length === 0) {
    return (
      <div className="flex h-48 items-center justify-center rounded-md border border-[color:var(--border-default)] bg-surface text-[12px] text-[color:var(--text-muted)]">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="shrink-0 overflow-hidden rounded-md border border-[color:var(--border-default)] bg-surface shadow-token-sm">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[960px] text-left" style={{ fontFamily: 'Inter, sans-serif' }}>
          <thead>
            <tr className={tableHeaderRowClass}>
              {selectable ? (
                <th className={`${tableHeaderCellClass} w-8`}>
                  <input type="checkbox" aria-label={allChecked ? 'Clear the selection' : 'Select all runs shown'} checked={allChecked}
                    onChange={() => onToggleAllChecked?.(!allChecked)} onClick={(e) => e.stopPropagation()} />
                </th>
              ) : null}
              {columns.map((col) => (
                <th key={col.key} className={tableHeaderCellClass}>
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr
                key={row.run_id}
                onClick={() => onRowClick?.(row)}
                className={`${tableRowClass} ${row.run_id === selectedRunId ? 'bg-surface-hover' : ''}`}
              >
                {selectable ? (
                  <td className={`${tableDataCellClass} w-8`} onClick={(e) => e.stopPropagation()}>
                    <input type="checkbox" aria-label={`Select run ${row.run_id}`} checked={checkedIds.has(row.run_id)}
                      onChange={() => onToggleChecked(row.run_id)} />
                  </td>
                ) : null}
                {columns.map((col) => (
                  <td key={col.key} className={tableDataCellClass}>
                    {renderCell(col.key, row, { onAnnotationClick })}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
